import { render, staticRenderFns } from "./SupportMenu.vue?vue&type=template&id=156ba1d9&"
import script from "./SupportMenu.vue?vue&type=script&lang=js&"
export * from "./SupportMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports